import { resources, type LocaleCode } from '../i18n';

export type SystemLocale = LocaleCode;
export type SystemSettingsCopy = typeof resources['en-US']['modules']['systemSettings'];

export function getSystemSettingsCopy(locale: SystemLocale): SystemSettingsCopy {
  return resources[locale].modules.systemSettings;
}

export function formatSystemCopy(template: string, values: Record<string, string | number>) {
  return template.replace(/\{(\w+)\}/g, (match, key) => String(values[key] ?? match));
}
